import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import reducer from './reducers';
const middleWare = [thunk];
const store = createStore(reducer, composeWithDevTools(applyMiddleware(...middleWare)));

export default store;
